@if (!!title) {
    <h3 class="is-summary-title is-level-3 has-text-weight-semibold pb-1">{{ title }}</h3>
}
<main role="main">
    <div class="main-content">
        @if (isCartEmpty) {
            <div class="columns is-desktop is-multiline is-marginless">
                <div class="column is-4">
                    <checkout-empty-cart-item
                        [isCartEmpty]="true"
                        [wallType]="'subscription'"
                        itemColor="tertiary"
                        itemIcon="tri-sim-card"
                        itemLabel="Besoin d'un forfait&nbsp;?"
                        ctaAriaLabel="Choisir un forfait"
                    />
                </div>
                <div class="column is-4">
                    <checkout-empty-cart-item
                        [isCartEmpty]="true"
                        [wallType]="'equipment'"
                        itemColor="tertiary"
                        itemIcon="tri-mobile"
                        itemLabel="Besoin d'un téléphone&nbsp;?"
                        ctaAriaLabel="Choisir un téléphone"
                    />
                </div>
                <div class="column is-4">
                    <checkout-empty-cart-item
                        [isCartEmpty]="true"
                        [wallType]="'fai'"
                        itemColor="tertiary"
                        itemIcon="tri-box"
                        itemLabel="Besoin d'une box&nbsp;?"
                        ctaAriaLabel="Choisir une Box"
                    />
                </div>
                <div class="column is-4 is-hidden-desktop">
                    <checkout-empty-cart-item
                        [isCartEmpty]="true"
                        wallType="accessory"
                        itemColor="tertiary"
                        itemIcon="tri-accessories"
                        itemLabel="Côté accessoires, vous n'oubliez rien&nbsp;?"
                        ctaAriaLabel="Choisir un accessoire"
                    />
                </div>

                <div class="column is-12 is-hidden-mobile is-hidden-tablet-only">
                    <checkout-empty-cart-item-horizontal
                        [isCartEmpty]="true"
                        wallType="accessory"
                        itemColor="tertiary"
                        itemIcon="tri-accessories"
                        itemLabel="Côté accessoires, vous n'oubliez rien&nbsp;?"
                        ctaAriaLabel="Choisir un accessoire"
                    />
                </div>
            </div>
        }
        @if (!isCartEmpty) {
            <div>
                <checkout-mixed-cart [cartForm]="form" [isSubmitted]="isSubmitted" />
            </div>
        }
    </div>
</main>
